import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconThumbsDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconThumbsDown"><Path fillRule="evenodd" clipRule="evenodd" d="M18.0022 4.5V12.5H20.5002V4.5H18.0022ZM17.5809 14H22.0002V3H6.58575C4.733 3 3.15858 4.35403 2.87996 6.1859L2.04344 11.6859C1.69829 13.9552 3.45391 16 5.74923 16H10.1134L9.67296 18.8264C9.41317 20.4935 10.7016 22 12.3891 22H13.4618L17.5809 14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconThumbsDown;
